const MAPTILER_KEY = import.meta.env.VITE_MAPTILER_KEY ?? new URLSearchParams(window.location.search).get("key") ?? "";
const MIN_ADDRESS_LENGTH = 3;

export { MAPTILER_KEY, MIN_ADDRESS_LENGTH };
